import React, { ReactNode, createContext, useContext } from 'react';
import { ApprovalService } from 'src/services/approvalService';

const ApprovalServiceContext = createContext<ApprovalService | undefined>(
  undefined
);

interface ApprovalServiceProviderProps {
  children: ReactNode;
}

export const ApprovalServiceProvider: React.FC<
  ApprovalServiceProviderProps
> = ({ children }) => {
  const approvalService = new ApprovalService();

  return (
    <ApprovalServiceContext.Provider value={approvalService}>
      {children}
    </ApprovalServiceContext.Provider>
  );
};

export const useApprovalService = (): ApprovalService => {
  const ApprovalService = useContext(ApprovalServiceContext);
  if (!ApprovalService) {
    throw new Error(
      'useApprovalService must be used within a ApprovalServiceProvider'
    );
  }
  return ApprovalService;
};
